import React, { useEffect, useState } from "react"
import { makeStyles } from "tss-react/mui"
import { PageHeader } from "../../../../shared/components/pageHeader/PageHeader"
import { LocalizedStrict } from "../../../localization/components/AppLocalized"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faInfoCircle } from "@fortawesome/pro-light-svg-icons"
import { Page } from "../../../../shared/components/pageHeader/PageHeaderApi"
import { useAppLocalization } from "../../../localization/components/AppLocalizationProvider"
import { Tab, Tabs } from "@mui/material"
import { TabPanel } from "../../../../shared/components/tabs/tabPanel"
import { TenantUsersTab } from "../components/TenantUsersTab"
import { Box } from "@mui/system"
import { TenantAdminsTab } from "../components/TenantAdminsTab"
import { useLocationQuery } from "../../../../core/router/routerHooks"
import { Breadcrumb, BreadcrumbLink, StandardBreadcrumbs } from "../../../../shared/components/links/StandardBreadcrumbs"
import { TENANT_ADMIN_ROUTE } from "../../../../constants/routes"

const useStyles = makeStyles()((_theme) => ({
    customerTable: {
        marginTop: "3rem",
    },
    singleCell: {
        verticalAlign: "baseline",
    },
}))

const tabIndex = {
    user: 0,
    admin: 1,
}

export function TenantUsers() {
    const { classes } = useStyles()

    const query = useLocationQuery()
    const tab = query.get("tab")

    const [activeTab, setActiveTab] = useState(0)
    function handleTabChange(event: React.SyntheticEvent, newActiveTab: number) {
        setActiveTab(newActiveTab)
    }

    useEffect(() => {
        if (tab === "user" || tab === "admin") {
            setActiveTab(tabIndex[tab])
        }
    }, [])

    const { l10n } = useAppLocalization()

    return (
        <>
            <LocalizedStrict id="office-manager-users-header" attrs={{ title: true }}>
                <PageHeader
                    page={Page.TENANT_USERS}
                    title="Users"
                    icon={<FontAwesomeIcon icon={faInfoCircle} />}
                >
                    <StandardBreadcrumbs>
                        <LocalizedStrict id="tenant-nav-item-home">
                            <BreadcrumbLink to={TENANT_ADMIN_ROUTE}>Home</BreadcrumbLink>
                        </LocalizedStrict>
                        <LocalizedStrict id="tenant-nav-item-organization-header">
                            <Breadcrumb>Organization</Breadcrumb>
                        </LocalizedStrict>
                        <LocalizedStrict id="tenant-nav-item-users">
                            <Breadcrumb>Users</Breadcrumb>
                        </LocalizedStrict>
                    </StandardBreadcrumbs>
                </PageHeader>
            </LocalizedStrict>

            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                <Tabs value={activeTab} onChange={handleTabChange}>
                    <Tab
                        value={tabIndex.user}
                        label={l10n.getString("office-manager-users-tab-users")}
                        wrapped
                        sx={{ textTransform: "none" }}
                    />
                    <Tab
                        value={tabIndex.admin}
                        label={l10n.getString("office-manager-users-tab-admins")}
                        wrapped
                        sx={{ textTransform: "none" }}
                    />
                </Tabs>
            </Box>
            <TabPanel value={activeTab} index={tabIndex.user}>
                <TenantUsersTab />
            </TabPanel>
            <TabPanel value={activeTab} index={tabIndex.admin}>
                <TenantAdminsTab />
            </TabPanel>
        </>
    )
}
